import { Hub } from "@aws-amplify/core";

let mockAccessToken: string | undefined;

const configure = () => {
  Hub.dispatch("auth", { event: "configured", data: "", message: "" });
  return true;
};

const getExpiration = () => Promise.resolve(new Date(2050, 1, 1).getTime());

const signIn = () => {
  mockAccessToken = "mock";
  Hub.dispatch("auth", { event: "signIn", data: "", message: "" });
  return true;
};

const signOut = () => {
  mockAccessToken = undefined;
  Hub.dispatch("auth", { event: "signOut", data: "", message: "" });
  return Promise.resolve(true);
};

const federatedSignIn = () => {};

const getAccessToken = () => {
  return Promise.resolve(mockAccessToken);
};

const currentAuthenticatedUser = () => Promise.resolve({});

const mockAuth = {
  configure,
  currentAuthenticatedUser,
  getExpiration: getExpiration,
  signIn: signIn,
  signOut: signOut,
  federatedSignIn: federatedSignIn,
  getAccessToken: getAccessToken,
};

export { mockAuth };
